import React from 'react';
import ClassAssembly5C  from 'views/ClassAssembly5C';

const ClassAssembly5CPage = () => {
    return <ClassAssembly5C />;
  };
  
  export default ClassAssembly5CPage;

  //5C